// extracted by mini-css-extract-plugin
module.exports = {"Form":"CommentCreateEditForm_Form__1Qeyz","Button":"CommentCreateEditForm_Button__sGFSX"};